import {Flex, Tab, TabList, TabPanel, TabPanels, Tabs, Text, useColorModeValue} from "@chakra-ui/react";
import DesignTab from "./DesignTab/DesignTab";
import SummaryTab from "./SummaryTab";
import ResultsTab from "./ResultsTab/ResultsTab";
import ReportsTab from "./ReportsTab";
import {FaRegEdit} from "react-icons/fa";
import {BsFileEarmarkBarGraph} from "react-icons/bs";
import {VscOutput} from "react-icons/vsc";
import {FaListCheck} from "react-icons/fa6";
import {useState} from "react";
import DocumentationTab from "./DocumentationTab";
import { IoDocumentOutline } from "react-icons/io5";


export const WorkspaceTabs = ({activeTab, setActiveTab}) => {

    const tabColor = useColorModeValue("gray.200","gray.600");
    const tabs = [
        <DesignTab setActiveTab={setActiveTab}/>,
        <SummaryTab setActiveTab={setActiveTab} activeTab={activeTab}/>,
        <ResultsTab setActiveTab={setActiveTab}/>,
        <ReportsTab setActiveTab={setActiveTab} />,
        <DocumentationTab/>
    ]
    return (
        <Tabs variant='enclosed' colorScheme='green' index={activeTab} onChange={(tabIndex) => setActiveTab(tabIndex)}>
            <TabList>
                <Tab>
                    <Flex align={"center"} gap={2}>
                        <FaRegEdit/>
                        <Text>Design</Text>
                    </Flex>
                </Tab>
                <Tab>
                    <Flex align={"center"} gap={2}>
                        <FaListCheck/>
                        <Text>Summary</Text>
                    </Flex>
                </Tab>
                <Tab>
                    <Flex align={"center"} gap={2}>
                        <VscOutput/>
                        <Text>Results</Text>
                    </Flex>
                </Tab>
                <Tab>
                    <Flex align={"center"} gap={2}>
                        <BsFileEarmarkBarGraph/>
                        <Text>Reports</Text>
                    </Flex>
                </Tab>
                <Tab>
                    <Flex align={"center"} gap={2}>
                        <IoDocumentOutline/>
                        <Text>Documentation</Text>
                    </Flex>
                </Tab>
            </TabList>
            <TabPanels>
                {
                    tabs.map(tab => (
                        <TabPanel  borderLeft={"1px"} h={"80vh"} borderRight={"1px"} borderBottom={"1px"} borderColor={tabColor}>
                            {tab}
                        </TabPanel>
                    ))
                }
            </TabPanels>
        </Tabs>
    );
};